import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const equipmentRequestsNewService = {
  async createRequest(userId: string, data: any) {
    await permissionEngine.assert(userId, 'equipment.requests.create', { 
      companyId: data.companyId,
      projectId: data.projectId 
    });
    
    const { data: request, error: reqError } = await supabase
      .from('equipment_requests')
      .insert({
        company_id: data.companyId,
        project_id: data.projectId,
        requester_id: userId,
        title: data.title,
        description: data.description,
        needed_from: data.neededFrom,
        needed_until: data.neededUntil || null,
        priority: data.priority || 'normal',
        status_code: 'requested',
      })
      .select()
      .single();

    if (reqError) throw reqError;

    if (data.items && data.items.length > 0) {
      const { error: itemsError } = await supabase
        .from('equipment_request_items')
        .insert(
          data.items.map((item: any) => ({
            request_id: request.id,
            equipment_type_id: item.equipmentTypeId,
            quantity: item.quantity,
            note: item.note,
          }))
        );

      if (itemsError) throw itemsError;
    }

    return request;
  },

  async getEquipmentCategories(companyId: string) {
    const { data, error } = await supabase
      .from('categories')
      .select('id, name')
      .eq('company_id', companyId)
      .eq('type', 'equipment'); // Assuming categories have a 'type' field
    if (error) throw error;
    return data;
  }
};
